/* HOLK LP behaviors */
(function(){
  function ready(fn){ if(document.readyState!='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    // ---- Gallery thumbs ----
    document.querySelectorAll('.holk-hero .gallery').forEach(function(g){
      var main = g.querySelector('.main img');
      g.querySelectorAll('.thumbs button').forEach(function(b){
        b.addEventListener('click',function(){
          var src = b.getAttribute('data-src');
          if(main && src){ main.src = src; }
          g.querySelectorAll('.thumbs button').forEach(function(x){x.classList.remove('active');});
          b.classList.add('active');
        });
      });
    });

    // ---- Bundle selector ----
    document.querySelectorAll('.holk-hero').forEach(function(hero){
      var bundles = hero.querySelectorAll('.bundle');
      var btn = hero.querySelector('.holk-buy-btn');
      function refresh(selected){
        bundles.forEach(function(b){ b.classList.toggle('selected', b===selected); });
        if(btn){
          var url = selected.getAttribute('data-url') || btn.getAttribute('data-default-url') || '#';
          btn.setAttribute('href', url);
          var price = selected.getAttribute('data-price');
          var label = btn.getAttribute('data-label-prefix') || 'BUY NOW';
          if(price) btn.innerHTML = label + ' &mdash; <strong>$' + price + '</strong>';
        }
      }
      bundles.forEach(function(b){ b.addEventListener('click',function(){ refresh(b); }); });
      var pre = hero.querySelector('.bundle.selected') || bundles[0];
      if(pre) refresh(pre);
    });

    // ---- Countdown timer ----
    document.querySelectorAll('.holk-ann .timer').forEach(function(t){
      var hours = parseInt(t.getAttribute('data-hours')||'24',10);
      var end = Date.now() + hours*3600*1000;
      var stored = localStorage.getItem('holk_lp_end');
      if(stored && parseInt(stored,10) > Date.now()){ end = parseInt(stored,10); }
      else { localStorage.setItem('holk_lp_end', String(end)); }
      function tick(){
        var ms = Math.max(0, end - Date.now());
        var h = Math.floor(ms/3600000);
        var m = Math.floor((ms%3600000)/60000);
        var s = Math.floor((ms%60000)/1000);
        var pad = function(n){ return n<10?'0'+n:''+n; };
        var spans = t.querySelectorAll('span b');
        if(spans.length>=3){ spans[0].textContent=pad(h); spans[1].textContent=pad(m); spans[2].textContent=pad(s); }
      }
      tick(); setInterval(tick,1000);
    });

    // ---- Floating CTA ----
    var floatBtn = document.querySelector('.holk-float');
    if(floatBtn){
      var threshold = 600;
      window.addEventListener('scroll', function(){
        if(window.scrollY > threshold) floatBtn.classList.add('show');
        else floatBtn.classList.remove('show');
      });
      var x = floatBtn.querySelector('.x');
      if(x){ x.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); floatBtn.style.display='none'; }); }
    }

    // ---- Smooth anchor scroll ----
    document.querySelectorAll('.holk-nav a.nlink[href^="#"]').forEach(function(a){
      a.addEventListener('click',function(e){
        var id = a.getAttribute('href').substring(1);
        var t = document.getElementById(id);
        if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
      });
    });
  });
})();
